import React from 'react';
import classNames from 'classnames';
import { EditableChangeEvent } from '../../utils/types/editable';
import Label from '../atoms/text/label';

interface ToggleProps {
	name: string;
	label: string;
	value: boolean;
	onChange: (e: EditableChangeEvent) => void;
	disabled?: boolean;
}

const Toggle = ({
	name,
	label,
	value,
	onChange,
	disabled = false,
}: ToggleProps) => {
	const toggleState = () => {
		if (!disabled) onChange({ target: { value: !value, name } });
	};

	const handleKeyDown = (event: React.KeyboardEvent) => {
		if (!disabled && (event.key === 'Enter' || event.key === ' ')) {
			event.preventDefault();
			toggleState();
		}
	};

	return (
		<Label
			className={classNames(
				'flex items-center gap-x-2 cursor-pointer select-none w-fit',
				{
					'text-primary': value && !disabled,
					'text-gray-txt': value && disabled,
					'text-gray': !value && !disabled,
					'pointer-events-none': disabled,
				}
			)}
			onClick={!disabled ? toggleState : undefined}
		>
			<div
				role="switch"
				aria-checked={value}
				tabIndex={disabled ? -1 : 0}
				onClick={toggleState}
				onKeyDown={handleKeyDown}
				className={classNames(
					'cursor-pointer w-12 h-7 flex items-center rounded-full p-1 transition-colors duration-300',
					{
						'bg-primary': value && !disabled,
						'bg-gray': !value && !disabled,
						'bg-gray-bg pointer-events-none': disabled,
					}
				)}
			>
				<div
					className={classNames(
						'w-5 h-5 rounded-full shadow-md transform transition-transform duration-300',
						{
							'bg-white': !disabled || (disabled && !value),
							'bg-gray-label': disabled && value,
							'translate-x-5': value,
							'translate-x-0': !value,
						}
					)}
				/>
			</div>
			{label}
		</Label>
	);
};

export default Toggle;
